import CbIcon from './src/icon.vue';

CbIcon.install = function(Vue) {
  Vue.component(CbIcon.name, CbIcon);
};

export default CbIcon;
